import Banner from '@carvana/ds-banner';
import { CheckFilledCvna } from '@carvana/ds-icons';
import { useToast } from '@carvana/ds-toast';
import React, { useCallback } from 'react';
import useAnalyticsContext from '|/hooks/use-analytics-context';
import styles from './VinEtchingBanner.module.css';
import { useTransferScheduleContext } from '../../contexts/transferSchedule';
import {
  declineVinEtching,
  loadTimeSlots
} from '../../contexts/transferSchedule/transferSchedule.actions';
import { VinEtchingAlertModal } from '../AlertModals';

const VinEtchingBanner = () => {
  const {
    state: { vinEtchingErrorModalOpen },
    transferScheduleDispatch
  } = useTransferScheduleContext();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  const { addToast } = useToast() as {
    addToast: (toast: {
      header: string;
      variant?: string;
      icon?: React.ReactNode;
      dismissal?: {
        type: string;
        showDismissButton: boolean;
      };
    }) => void;
  };
  const { trackEvent } = useAnalyticsContext();

  const handleDeclineVinEtching = useCallback(() => {
    trackEvent('VIN Etching Declined', {
      url: window.location.pathname,
      metadata: {
        action: 'decline_vin_etching',
        location: 'transfer_schedule_banner'
      }
    });
    void (async () => {
      try {
        transferScheduleDispatch({ type: 'DECLINE_VIN_ETCHING_START' });

        await Promise.all([
          declineVinEtching(transferScheduleDispatch),
          loadTimeSlots(transferScheduleDispatch)
        ]);

        transferScheduleDispatch({ type: 'DECLINE_VIN_ETCHING_SUCCESS' });

        addToast({
          header: 'VIN marking service declined',
          variant: 'default',
          icon: <CheckFilledCvna />,
          dismissal: {
            type: 'auto',
            showDismissButton: false
          }
        });
      } catch (error: unknown) {
        transferScheduleDispatch({ type: 'DECLINE_VIN_ETCHING_ERROR' });
        transferScheduleDispatch({ type: 'OPEN_VIN_ETCHING_ERROR_MODAL' });
      }
    })();
  }, [transferScheduleDispatch, addToast, trackEvent]);

  const handleRetryDecline = useCallback(() => {
    transferScheduleDispatch({ type: 'CLOSE_VIN_ETCHING_ERROR_MODAL' });
    handleDeclineVinEtching();
  }, [handleDeclineVinEtching, transferScheduleDispatch]);

  return (
    <>
      <div className={styles.bannerContainer}>
        <Banner align="left" icon open type="warning">
          <Banner.Headline>
            Due to VIN marking, the earliest available appointment is in six weeks
          </Banner.Headline>
          <Banner.Message>
            Don&apos;t want to wait? You can decline this service to receive your vehicle sooner.
          </Banner.Message>
          <Banner.Button
            onClick={handleDeclineVinEtching}
            data-analytics-id="pp_SD_remove_VIN_etching"
          >
            Decline VIN marking
          </Banner.Button>
        </Banner>
      </div>

      <VinEtchingAlertModal
        isOpen={vinEtchingErrorModalOpen}
        onClose={() => {
          transferScheduleDispatch({ type: 'CLOSE_VIN_ETCHING_ERROR_MODAL' });
        }}
        onButtonClick={handleRetryDecline}
      />
    </>
  );
};

export default VinEtchingBanner;
